import { useState, useRef, useEffect } from 'react';

export default () => {
  const [showBackToTopButton, setShowBackToTopButton] = useState(false);
  const blockContentRef = useRef<HTMLDivElement>(null);

  /* handle scroll event */
  const handleScroll = () => {
    // Get the container that has the blog content
    const blockContent = blockContentRef.current;

    if (!blockContent) return;  
    
    // Get the height of the blockContent container
    const blockContentHeight = blockContent?.scrollHeight || 0;
    // Get the first text element (either the heading or paragraph) and get the distance from the top of the screen for that first text element
    const firstTextElementPostion = blockContent?.querySelector('h2, p')?.getBoundingClientRect()?.top || 0;
    // Take a thirty percent of the content height as the offset amount meaning when this amount of the content is off screen we show the button
    const offsetHeight = blockContentHeight * 0.3;
    // Show the button if the container is more than twice the viewport height (dont show the button if there is not much to scroll)
    // AND the top of the first text element is more than the offset above the top of the visible screen
    if ((blockContentHeight > 2 * window.innerHeight) && (firstTextElementPostion <= -(offsetHeight || 0))) {
      setShowBackToTopButton(true);
    } else {
      setShowBackToTopButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    showBackToTopButton,
    blockContentRef,
  };
};
